import lodash from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { Tabs, Tab, TablePagination } from '@material-ui/core';
import { SET_LEAD_PAYMENT_APPROVAL_DATA, GET_LEAD_PAYMENT_APPROVAL_DATA } from '../constants';

class TableTabs extends Component {
    refreshData = lodash.debounce((isCount) => {
        const { dispatch } = this.props;

        dispatch({ type: GET_LEAD_PAYMENT_APPROVAL_DATA, isCount });
    }, 500, { leading: true, trailing: false });

    handleChangeTab = (event, tab) => {
        const { dispatch } = this.props;

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DATA,
            payload: {
                'filters.waitingApproval': tab,
            },
        });

        this.refreshData(true);
    };

    handleChangePage = (event, page) => {
        const { dispatch, pagination } = this.props;

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DATA,
            payload: {
                'pagination.page': page,
                'pagination.offset': page * pagination.rpp,
            },
            refreshPaths: ['pagination'],
        });

        this.refreshData();
    };

    handleChangeRpp = (event) => {
        const { dispatch } = this.props;
        const rpp = event.target.value;

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DATA,
            payload: {
                'pagination.rpp': rpp,
            },
            refreshPaths: ['pagination'],
        });

        this.refreshData();
    };


    render() {
        const { dataCount, pagination, waitingApproval } = this.props;

        return (
            <Row>
                <Col span={16}>
                    <Tabs
                        value={waitingApproval}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleChangeTab}
                        aria-label="Leads payment approval tabs"
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label="All" value="all" />
                        <Tab label="Waiting Purchasing" value="purchasing" />
                        <Tab label="Waiting Transport" value="transport" />
                        <Tab label="Waiting Accounts" value="accounts" />
                    </Tabs>
                </Col>
                <Col span={8}>
                    <TablePagination
                        rowsPerPageOptions={pagination.rppOptions}
                        component="div"
                        count={dataCount}
                        rowsPerPage={pagination.rpp}
                        page={pagination.page}
                        backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                        nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRpp}
                    />
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => ({
    pagination: state.Leads.LeadPaymentApproval.pagination,
    dataCount: state.Leads.LeadPaymentApproval.dataCount,
    waitingApproval: state.Leads.LeadPaymentApproval.filters.waitingApproval,
});

export default connect(mapStateToProps)(TableTabs);



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/components/TableTabs.js